import { Component } from '@angular/core';

@Component({
  selector: 'app-luci',
  templateUrl: './luci.component.html',
  styleUrls: ['./luci.component.scss']
})
export class LuciComponent { }
